//#region src/lib/cx.ts
/** Joins class names, skipping falsy values. */
function cx(...classes) {
	return classes.filter(Boolean).join(" ");
}
//#endregion
export { cx };

//# sourceMappingURL=cx.js.map